import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { LoggedOnUserPermissionsStore } from 'app/store/permissions.auth.store';
import { filter, of, switchMap, take } from 'rxjs';

export const ClientOnlyGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const permissionsStore = inject(LoggedOnUserPermissionsStore);

    return toObservable(computed(() => ({ isLoaded: permissionsStore.isLoaded()})))
    .pipe(
        filter(({isLoaded}) => isLoaded),
        take(1),
        switchMap(() => {
            if (permissionsStore.isMerchant()) {
                return of(true);
            }

            return of(router.parseUrl('error'));
        }));
};